if (!customElements.get('aw-collection-gallery')) {
  customElements.define('aw-collection-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.aw-gallery__track');
      this.querySelectorAll('[data-gallery-clone]').forEach(node => node.remove());
      this.cards = [...this.querySelectorAll('.aw-gallery__card')];
      this.dots = [...this.querySelectorAll('[data-gallery-index]')];
      this.active = 0;
      if (!this.track || !this.cards.length) return;
      this.querySelector('.aw-gallery__navigation').hidden = this.cards.length < 2;
      this.cells = this.cards.map((card, index) => ({ card, index, clone: false }));
      if (this.cards.length > 1) {
        const before = this.clone(this.cards.at(-1));
        const after = this.clone(this.cards[0]);
        this.track.prepend(before);
        this.track.append(after);
        this.cells.unshift({ card: before, index: this.cards.length - 1, clone: true });
        this.cells.push({ card: after, index: 0, clone: true });
      }
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-gallery-index')) this.go(Number(button.dataset.galleryIndex));
        if (button.hasAttribute('data-gallery-step')) this.step(Number(button.dataset.galleryStep));
      }, options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.cards.length - 1);
        else this.step(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => {
          this.update();
          if (this.nearest?.clone) this.go(this.nearest.index, 'auto');
        }, 160);
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.indexOf(event.target.closest('.aw-gallery__card'));
        if (index >= 0) this.go(index);
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.go(this.active, 'auto'));
      this.resizeObserver.observe(this.track);
      this.go(0, 'auto');
      this.update();
    }
    clone(card) {
      const copy = card.cloneNode(true);
      copy.setAttribute('data-gallery-clone', '');
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('inert', '');
      copy.removeAttribute('data-shopify-editor-block');
      return copy;
    }
    step(direction) {
      if (direction < 0 && this.active === 0) this.move(this.cells[0].card);
      else if (direction > 0 && this.active === this.cards.length - 1) this.move(this.cells.at(-1).card);
      else this.go(this.active + direction);
    }
    go(index, behavior) {
      const bounded = Math.max(0, Math.min(index, this.cards.length - 1));
      this.move(this.cards[bounded], behavior);
    }
    move(card, behavior) {
      const trackRect = this.track.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      this.track.scrollTo({
        left: this.track.scrollLeft + cardRect.left - trackRect.left - (trackRect.width - cardRect.width) / 2,
        behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth')
      });
    }
    update() {
      const rect = this.track.getBoundingClientRect();
      const center = rect.left + rect.width / 2;
      let closest = Infinity;
      this.cells.forEach(cell => {
        const box = cell.card.getBoundingClientRect();
        const distance = Math.abs(box.left + box.width / 2 - center);
        if (distance < closest) { closest = distance; this.nearest = cell; this.active = cell.index; }
      });
      this.dots.forEach((dot, index) => {
        if (index === this.active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      clearTimeout(this.settleTimer);
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
